import { TFunction } from 'i18next';
import * as yup from 'yup';

interface ForgotPasswordValidationObject {
  email: string;
}

export const forgotPasswordValidationSchema = (
  t: TFunction<'translation', undefined>
) =>
  yup.object<ForgotPasswordValidationObject>({
    email: yup
      .string()
      .email(t('account.forgot-password.email-inline-error'))
      .required('account.forgot-password.email-required-error'),
  });
